import { GetterTree } from "vuex";

import { RootState } from "@/store";

import { State } from "./state";

export type Getters = {
  sidebarStatus(state: State): string;
  filterStatus(state: State): boolean;
  loader(state: State): boolean;
  companies(state: State): Array<any>;
  sites(state: State): Array<any>;
  groups(state: State): Array<any>;
  companyAssets(state: State): Array<any>;
  settings(state: State): any;
  smtpSettings(state: State): any;
  alert(state: State): any;
  getSelectedRow(state: State): any;
  compKey(state: State): any;
  exportStatus(state: State): any;
  exportDataLoaded(state: State): any;
  rowOpened(state: State): any;
  appGroups(state: State): Array<any>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  sidebarStatus: (state) => state.sidebarStatus,
  filterStatus: (state) => state.filterStatus,
  loader: (state) => state.loader,
  companies: (state) => state.companies,
  groups: (state) => state.groups,
  sites: (state) => state.sites,
  companyAssets: (state) => state.companyAssets,
  settings: (state) => state.settings,
  smtpSettings: (state) => state.smtpSettings,
  alert: (state) => state.alert,
  getSelectedRow: (state) => state.alert,
  compKey: (state) => state.compKey,
  exportStatus: (state) => state.exportStatus,
  exportDataLoaded: (state) => state.exportDataLoaded,
  rowOpened: (state) => state.rowOpened,
  selectedDecision: (state) => state.selectedDecision,
  partners: (state) => state.partners,
  appGroups: (state) => state.appGroups,
  appGroupsProcess: (state) => state.appGroupsProcess,
  appGroupsFileAccess: (state) => state.appGroupsFileAccess,
  appGroupsRegistryAccess: (state) => state.appGroupsRegistryAccess,
  appGroupsCodeLoad: (state) => state.appGroupsCodeLoad,
  appGroupsChildLaunch: (state) => state.appGroupsChildLaunch,
  globalPolicies: (state) => state.globalPolicies,
  globalPolicyFileAccess: (state) => state.globalPolicyFileAccess,
  globalPolicyRegistryAccess: (state) => state.globalPolicyRegistryAccess,
  globalPolicyCodeLoad: (state) => state.globalPolicyCodeLoad,
  enumsList: (state) => state.enums,
  folderMaps: (state) => state.folderMaps,
  publisherList: (state) => state.publisherList,
  appGroupInfo: (state) => state.appGroupInfo
};
